import { IconTable } from '@components/table/IconTable';
// import TooltipIconComponent from '@components/TooltipIconComponent/TooltipIconComponent';
import { useFetchBuildingTopChanges } from 'api/anomalies/anomalyServices';
import { CardContainer } from 'layout/Card';
import { type FC, useMemo, useState } from 'react';
import useGetMostImportantChangesTableColumns from './useGetMostImportantChangesTableColumns';
import clsx from 'clsx';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { useNavigate } from 'react-router-dom';
import { type Anomaly } from 'interfaces/change/ChangeData.interface';
import { useSeverity } from 'hooks/contexts/SeverityContext';

interface MostImportantChangesTableProps {
  buildingId?: string;
  severity?: string;
}

const MostImportantChangesTable: FC<MostImportantChangesTableProps> = ({
  buildingId,
  severity,
}) => {
  const [hoveredId, setHoveredId] = useState<number | undefined>();
  const { theme } = useTheme();
  const { data, isFetching } = useFetchBuildingTopChanges(buildingId);
  const { columns } = useGetMostImportantChangesTableColumns();
  const navigate = useNavigate();
  const { getSeverityBorderColor, getSeveritySmileyIcon } = useSeverity();

  const effectiveness = useMemo(() => {
    const meters = data?.anomaly_detections;
    if (meters && meters.length > 0) {
      return !meters.some((meter) => meter.impact_average_diff_euro > 50);
    }
    return undefined;
  }, [data]);

  const navigateToAnomaly = (anomaly: Anomaly): void => {
    if (anomaly) navigate(`/app/operations/anomalies/details/${anomaly.id}`);
  };

  return (
    <div className={clsx('rounded-lg', getSeverityBorderColor(severity))}>
      <CardContainer>
        {/* <div className="flex items-center justify-between py-2">
          <div className="flex items-center gap-4">
            <h3 className="font-bold text-base">Most important</h3>
            <TooltipIconComponent content="The 3 most significant changes in consumption pattern that have been identified linked to this building" />
          </div>
          {effectiveness !== undefined && getSeveritySmileyIcon(severity)}
          </div> */}
        {effectiveness !== undefined && getSeveritySmileyIcon(severity)}
        <IconTable
          minHeight={300}
          maxHeight={300}
          skeletonAmountWhenLoading={5}
          isFetching={isFetching}
          enableRowBorder={false}
          stripped={false}
          hoverColor={theme.colors['primary-lighter']}
          hoveredId={hoveredId}
          onRowHover={setHoveredId}
          enableRowRoundedBorder={true}
          data={data?.anomaly_detections ?? []}
          columns={columns}
          onClickRow={navigateToAnomaly}
          emptyTableMessage="No important changes detected"
        />
      </CardContainer>
    </div>
  );
};
export default MostImportantChangesTable;
